export default __webpack_public_path__ + "static/media/ecommerce-3562005_1920.9e324862.jpg";